import script from "./AlertBox.vue?vue&type=script&setup=true&lang=js"
export * from "./AlertBox.vue?vue&type=script&setup=true&lang=js"

import "./AlertBox.vue?vue&type=style&index=0&id=e8d38a9a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e8d38a9a"]])

export default __exports__